import React, { Component } from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';

import moment from 'moment';

import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import Select from 'helpers/reduxFormMaterialUiNext/Select';
import { AccentColor } from 'helpers/AccentColorHelper';

import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import IconButton from 'material-ui/IconButton';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import { CSSTransitionGroup } from 'react-transition-group';

import * as validator from 'helpers/Validator';
import * as format from 'helpers/Formatter';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import { featureEnabled } from 'helpers/ToggleBot';
import { getTranslatedString } from 'helpers/i18n';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';

class renderQuestionOptions extends Component {
  UNSAFE_componentWillMount() {
    const { fields } = this.props;
    if (!fields.length) fields.push();
  }

  render() {
    const { fields } = this.props;

    return (
      <div style={{ padding: '0 30px', maxWidth: '300px', margin: 'auto' }}>
        <CSSTransitionGroup
          transitionName="add_question_option"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {fields.map((question, index) => (
            <div key={index}>
              <h5 style={{ lineHeight: '26px', color: '#4e4e4e', marginBottom: '5px' }}>
                {getTranslatedString('landlordPortal.surveys.option')} #{index + 1}
                {index > 0 && (
                  <IconButton
                    style={{
                      padding: 0,
                      verticalAlign: 'text-bottom',
                      width: 'none',
                      height: 'none',
                      float: 'right',
                    }}
                    onClick={() => fields.remove(index)}
                  >
                    <DeleteIcon size={24} style={{ padding: 0 }} />
                  </IconButton>
                )}
              </h5>

              <div className="row">
                <div className="col-xs-12" style={{ padding: 0 }}>
                  <Field
                    name={`${question}.option`}
                    type="text"
                    component={TextField}
                    label={getTranslatedString('landlordPortal.surveys.option')}
                    style={{ fontSize: '14px' }}
                    validate={[validator.required]}
                  />
                </div>
              </div>
            </div>
          ))}

          <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
            <FlatButton
              label={getTranslatedString('landlordPortal.surveys.addOption')}
              type="button"
              hoverColor="grey"
              style={{ color: AccentColor() }}
              onClick={() => {
                fields.push({});
              }}
            />
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

class RenderQuestions extends Component {
  UNSAFE_componentWillMount() {
    const { fields } = this.props;
    if (!fields.length) fields.push();
  }

  render() {
    const { fields, isPoll } = this.props;

    const QUESTION_TYPE_MULTIPLE_CHOICE = 1;

    return (
      <div>
        <CSSTransitionGroup
          transitionName="add_survey_question"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {fields.map((question, index) => (
            <div key={index}>
              <h4 style={{ lineHeight: '26px' }}>
                {isPoll
                  ? getTranslatedString('landlordPortal.surveys.pollQuestion')
                  : `${getTranslatedString('landlordPortal.surveys.question')} #${index + 1}`}
                {index > 0 && (
                  <IconButton
                    style={{
                      padding: 0,
                      verticalAlign: 'text-bottom',
                      width: 'none',
                      height: 'none',
                      float: 'right',
                    }}
                    onClick={() => fields.remove(index)}
                  >
                    <DeleteIcon size={24} style={{ padding: 0 }} />
                  </IconButton>
                )}
              </h4>

              <div className="row">
                <div className="row">
                  <div className="col-xs-12" style={{ padding: 0 }}>
                    <Field
                      name={`${question}.question`}
                      type="text"
                      component={TextField}
                      label={getTranslatedString('landlordPortal.surveys.question')}
                      style={{ fontSize: '14px' }}
                      validate={[validator.required]}
                    />
                  </div>
                </div>
                {!isPoll && (
                  <div className="row">
                    <div className="col-xs-12" style={{ padding: 0, marginTop: '10px' }}>
                      <FormControl>
                        <InputLabel htmlFor="time">
                          {getTranslatedString('landlordPortal.surveys.questionType')}
                        </InputLabel>
                        <Field
                          name={`${question}.question_type`}
                          component={Select}
                          placeholder={getTranslatedString('landlordPortal.surveys.questionType')}
                          style={{ fontSize: '14px' }}
                          validate={[validator.required]}
                        >
                          <MenuItem value={0}>
                            {getTranslatedString('landlordPortal.surveys.shortText')}
                          </MenuItem>
                          <MenuItem value={1}>
                            {getTranslatedString('landlordPortal.surveys.multipleChoice')}
                          </MenuItem>
                          <MenuItem value={2}>
                            {getTranslatedString('landlordPortal.surveys.yesNo')}
                          </MenuItem>
                          <MenuItem value={3}>
                            {getTranslatedString('landlordPortal.surveys.ratingOutOfFive')}
                          </MenuItem>
                          {featureEnabled('ui.surveys.ten_scale_rating') && (
                            <MenuItem value={5}>
                              {getTranslatedString('landlordPortal.surveys.ratingOutOfTen')}
                            </MenuItem>
                          )}
                        </Field>
                      </FormControl>
                    </div>
                  </div>
                )}

                {((fields.get(index) &&
                  fields.get(index).question_type === QUESTION_TYPE_MULTIPLE_CHOICE) ||
                  isPoll) && (
                  <FieldArray
                    name={`${question}.question_option`}
                    component={renderQuestionOptions}
                  />
                )}
              </div>
            </div>
          ))}

          {!isPoll && (
            <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
              <FlatButton
                label={getTranslatedString('landlordPortal.surveys.addAdditionalQuestion')}
                type="button"
                backgroundColor={AccentColor()}
                hoverColor="grey"
                style={{ color: 'white' }}
                onClick={() => {
                  fields.push({});
                }}
              />
            </div>
          )}
        </CSSTransitionGroup>
      </div>
    );
  }
}

class Survey extends Component {
  constructor(props) {
    super(props);
    let isPoll = false;
    let isEditing = false;
    if (props.initialValues) {
      isPoll = props.initialValues.is_poll;
      isEditing = true;
    }
    this.state = {
      isPoll: isPoll,
      isEditing: isEditing,
    };
  }

  render() {
    const { handleSubmit, properties } = this.props;

    const style = {
      receipt_header: {
        margin: '5px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
      },
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.surveys.surveyDetails')}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12" style={{ padding: 0, marginBottom: '7px' }}>
            <Field
              name="title"
              type="text"
              component={TextField}
              label={getTranslatedString('landlordPortal.surveys.surveyName')}
              style={{ fontSize: '14px' }}
              validate={[validator.required]}
            />
          </div>
          <div className="col-xs-12" style={{ padding: 0 }}>
            <Field
              name="description"
              type="text"
              component={TextField}
              label={getTranslatedString('landlordPortal.surveys.surveyDescription')}
              style={{ fontSize: '14px' }}
              validate={[validator.required]}
            />
          </div>
          <div
            className="col-xs-12"
            style={{ padding: 0, marginTop: '15px', marginBottom: '15px' }}
          >
            <label
              style={{
                width: '100%',
                textAlign: 'initial',
                fontSize: '11px',
                margin: '11px -10px -10px 15px',
                marginLeft: '15px',
                position: 'absolute',
                top: '-6px',
              }}
              aria-label={getTranslatedString('landlordPortal.surveys.expirationDate')}
            >
              {getTranslatedString('landlordPortal.surveys.expirationDate')}
            </label>
            <Field
              name="expiration_date"
              component={DatePickerAccessible}
              style={{
                fontSize: '14px',
                zIndex: 5000,
              }}
              formatDate={format.reformatDate}
              autoOk={true}
              textFieldStyle={{
                fontSize: '14px',
              }}
              minDate={new Date(moment(new Date()).add(1, 'days'))}
              disableYearSelection={true}
            />
          </div>
          <div className="col-xs-12" style={{ padding: 0, marginBottom: '15px' }}>
            <Field
              name="properties"
              data={properties}
              component={MultiSelectExtended}
              multiple={true}
              hintText={getTranslatedString('landlordPortal.surveys.properties')}
              innerDivStyle={{
                width: '100%',
                fontSize: '14px',
                fontWeight: '100 !important',
              }}
              menuStyle={{ minWidth: '250px', fontSize: '14px' }}
              style={{ fontSize: '15px' }}
              validate={[validator.required]}
              fullWidth
              withResetSelectAllButtons
            />
          </div>
          {!this.state.isEditing && !this.state.isPoll && (
            <div className="col-xs-12" style={{ padding: 0, marginBottom: '15px' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '14px' }}>
                  {getTranslatedString('landlordPortal.surveys.isSingleQuestionPoll')}
                </div>
              </div>
              <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '15px' }}>
                <BooleanRadioButtons
                  name="is_poll"
                  style={{ width: '187px', margin: 'auto' }}
                  onUpdate={(value) => {
                    this.setState({ isPoll: value });
                  }}
                />
              </div>
            </div>
          )}
        </div>

        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.surveys.surveyQuestions')}
            </p>
          </div>
        </div>
        <FieldArray
          name="survey_questions"
          component={RenderQuestions}
          isPoll={this.state.isPoll}
        />
      </form>
    );
  }
}

Survey = reduxForm({
  form: 'create_survey_form',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
  initialValues: { properties: [] },
})(Survey);

export default Survey;
